export default __webpack_public_path__ + "static/char-17-edc76f2430c489cf815f81533c116328.gif";